import "@fontsource-variable/jetbrains-mono";
import "@fontsource-variable/manrope";
import "@fontsource-variable/rubik";
import "./theme/globals.css";
import "./theme/legacy.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { initLocale } from "./i18n";
import { installChunkReload } from "./layout/chunkReload";
import { getMode } from "./theme/mode";

// Apply the colour mode before the first paint.
getMode();
// A tab open across a deploy reloads instead of failing on a missing chunk (S65).
installChunkReload();

// The chosen language's messages load before the first render (D70).
void initLocale().then(() =>
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
);
